export const SESSION_STORAGE_SESSION_SOURCE_PARAMS_KEY = 'utm_params';
